import { Badge } from '../../../components/ui/Badge'
import formStyles from '../../../components/ui/Form.module.css'
import { PROJECT_DOC_OPTIONS } from './projectDocs'
import type { ProjectDocId } from '../../../api/types'

interface ProjectDocsPickerProps {
  selected: ProjectDocId[]
  onToggle: (id: ProjectDocId) => void
  /** 'checkbox' fürs Anlegen-Formular, 'chips' für die kompakte Read-only-nahe Detailansicht. */
  variant?: 'checkbox' | 'chips'
}

export function ProjectDocsPicker({ selected, onToggle, variant = 'checkbox' }: ProjectDocsPickerProps) {
  if (variant === 'chips') {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }}>
        {PROJECT_DOC_OPTIONS.map((opt) => {
          const isSelected = selected.includes(opt.value)
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onToggle(opt.value)}
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', opacity: isSelected ? 1 : 0.45 }}
            >
              <Badge variant={isSelected ? 'accent' : 'neutral'}>{opt.label}</Badge>
            </button>
          )
        })}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }}>
      {PROJECT_DOC_OPTIONS.map((opt) => (
        <label
          key={opt.value}
          className={formStyles.checkboxRow}
          style={{ border: '1px solid var(--surface-border)', borderRadius: 'var(--radius-md)', padding: '4px 10px' }}
        >
          <input type="checkbox" checked={selected.includes(opt.value)} onChange={() => onToggle(opt.value)} />
          {opt.label}
        </label>
      ))}
    </div>
  )
}
